import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DirectivesModule } from 'app/directives/directives.module';
import {
    FcpAlertModule,
    FcpButtonModule,
    FcpCardModule,
    FcpChipModule,
    FcpDropdownModule,
    FcpFormFieldModule,
    FcpIconModule,
    FcpInputModule,
    FcpModalModule
} from 'fc-ui-components';
import { SharedModule } from 'shared/shared.module';
import { SingleStoreModalForCopyingComponent } from './single-store-modal-for-copying.component';
import { DetailedSizeFilterModule } from '../../detailed-size-filter/detailed-size-filter.module';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        FcpModalModule,
        FcpButtonModule,
        ReactiveFormsModule,
        SharedModule,
        FcpFormFieldModule,
        FcpIconModule,
        FcpInputModule,
        FcpCardModule,
        DirectivesModule,
        FcpAlertModule,
        FcpAlertModule,
        FcpAlertModule,
        FcpDropdownModule,
        DetailedSizeFilterModule,
        FcpChipModule
    ],
    declarations: [SingleStoreModalForCopyingComponent],
    exports: [SingleStoreModalForCopyingComponent]
})
export class SingleStoreModalForCopyingModule {}
